import { useAppStore } from '@/core/stores/appStore';
import { useProfile } from '@/modules/auth/hooks/useProfile';
import { useEffect } from 'react';
import { Platform } from 'react-native';

/**
 * Web: after the persisted session loads, refetch GET /v1/customers/profile-details
 * once per browser load so owned units (including `isADHAUnit` / `status`) match
 * the latest response. ADHA journey keeps its own catalogue refresh.
 */
export function useRefreshNormalCustomerProfile(): void {
  const hasHydrated = useAppStore((state) => state._hasHydrated);
  const isAdhaJourney = useAppStore((state) => state.isAdhaJourney);
  const isAuthenticated = useAppStore((state) => state.auth.isAuthenticated);
  const { fetchProfile } = useProfile();

  useEffect(() => {
    if (Platform.OS !== 'web' || !hasHydrated || isAdhaJourney || !isAuthenticated) {
      return;
    }
    void fetchProfile();
  }, [fetchProfile, hasHydrated, isAdhaJourney, isAuthenticated]);
}
